<div #wrapperElement class="panel-wrapper" [class.has-external-items]="hasExternalItems">
    @if (displayBackButton) {
    <div class="back-button">
        <h-back-button
            id="go-back-faq"
            [appearance]="'secondary'"
            [shouldInheritHeight]="isMobile"
            (pressed)="handleGoBack()">
            <span class="mobile-only" i18n="@@node--hermes-product-display-default.back" hSrOnlyNoSnippet> Back </span>
            <span class="desktop-only" i18n="@@node--hermes-product-display-default.back"> Back </span>
            <span hSrOnlyNoSnippet>
                {{ "&nbsp;" }}
                <ng-container i18n="@@hermes.accessibility.catalog.link.to-product-grid">
                    to the product grid
                </ng-container>
            </span></h-back-button
        ></div
    >
    }

    <!-- Toggles block can be displayed in selector or after items -->

    <ng-template #toggles>
        @if(displayFooterDetail) {
        <div class="product-toggles">
            @if(productToggles) {
            <h-product-toggles
                [backgroundColor]="transparentColor"
                [productToggles]="productToggles"
                (expandToggle)="onExpandToggle($event)"></h-product-toggles>
            }
            <h-product-info-footer
                [productReference]="productReference !== undefined ? productReference : productInputSignal().sku"
                [isComposite]="isComposite"
                [agecLinks]="productInputSignal().agecLinks ?? []"
                [specificTermsOfProductUse]="
                    productInputSignal().simpleAttributes?.specificTermsOfProductUse ?? false
                "></h-product-info-footer>
        </div>
        }
    </ng-template>
    @if (!productPageFacade.isProductPageSelectorRevampEnabled) {
    <div class="selector-panel">
        <div>
            <div class="selector-header">
                @if(productInputSignal().attributes) {
                <h-product-info-header [product]="productInputSignal()"></h-product-info-header>
                <!-- Image for desktop -->
                }
                <span
                    id="product-info"
                    hSrOnlyNoSnippet
                    role="heading"
                    i18n-role
                    aria-level="2"
                    i18n="@@hermes.commerce.product_locator.product_information.label">
                    Product information
                </span>
            </div>

            @if (selectorPosition === SelectorPositionStatus.TOP) {
            <ng-container *ngTemplateOutlet="selectorPage"></ng-container>
            } @if(productInputSignal().attributes) {
            <h-product-info-attributes
                class="selector-attributes"
                [product]="productInputSignal()"
                [backgroundOpacity]="true"
                [spacingBottom]="false"
                [marginBottom]="!hasExternalItems"></h-product-info-attributes>
            } @if (selectorPosition === SelectorPositionStatus.BOTTOM) {
            <ng-container *ngTemplateOutlet="selectorPage"></ng-container>
            }

            <!-- Specific page selector Template  -->
            <ng-template #selectorPage>
                <div class="selector-product">
                    <ng-content select="[selector]"></ng-content>
                </div>
            </ng-template>

            <!-- Display toggles here for any case expect mobile and has external items -->
            <ng-container [ngTemplateOutlet]="toggles"></ng-container>
        </div>
    </div>
    }

    <div class="carousel-panel">
        @if(isMobile === false && carouselAssetsSignal().length > 0) {
        <div i18n class="images-galery">
            <h-images-gallery
                [displayVideoPoster]="true"
                [product]="productInputSignal()"
                [backgroundWhite]="backgroundWhite"
                [prefixTab]="'gallery-template'"
                [currentIndex]="imagesIndex"
                (indexChange)="handleImageGalleryChangeIndex($event)"></h-images-gallery>
        </div>
        } @if (carouselAssetsSignal()) {
        <div class="carousel-container">
            <h-carousel
                #carousel
                [mousewheel]="!isMobile ? MOUSEWHEEL_OPTIONS : false"
                [isMobile]="isMobile"
                [isControlsDisplayed]="false"
                [breakpointsConfiguration]="breakpontsConfiguration"
                [isSimulateTouchEnabled]="true"
                [isDotsFocusable]="false"
                [optimizeTransformAnimation]="true"
                (slideChanged)="handleSlideChange($event)"
                [slidesOffsetAfter]="slidesOffsetSignal()"
                (transitionEnd)="updateSnapGrid()"
                (sliderFirstMove)="onSliderFirstMove()">
                <span
                    hsronlynosnippet
                    role="heading"
                    i18n-role
                    aria-level="2"
                    i18n="@@hermes.accessibility.product-images-gallery-title"
                    class="simple-product-title">
                    Image gallery
                </span>
                @for (asset of carouselAssetsSignal(); track trackByAssetIndex(idx); let idx = $index) {
                <div [id]="'tabpanel-default-' + idx" role="tabpanel" class="asset-wrapper" *hSlide>
                    @if( asset.type === assetMediaType.Image || (asset.type === assetMediaType.Video && (!isMobile ||
                    isServer))){

                    <button
                        aria-haspopup="dialog"
                        i18n-aria-haspopup
                        [attr.aria-labelledby]="'zoom-label-' + idx"
                        aria-expanded="false"
                        class="custom-focus"
                        tabindex="{{ idx === carouselIndex ? 0 : -1 }}"
                        id="slide-{{ idx }}"
                        (keydown)="
                            handleKeyNavigation($event, {
                                carouselCurrentIndex: idx,
                                assetType: asset.type
                            })
                        "
                        (click)="
                            openZoomModal({
                                carouselCurrentIndex: idx,
                                assetType: asset.type
                            })
                        "
                        (focus)="handleFocus()">
                        @if (asset.type === assetMediaType.Image) {
                        <img
                            [class.background-white]="backgroundWhite"
                            [ngSrc]="asset.url"
                            [alt]="asset.title"
                            [width]="productImageIntrinsecSize"
                            [height]="productImageIntrinsecSize"
                            [priority]="idx === 0 || idx === 1"
                            (load)="onImageReady()" />
                        }@else {
                        <ng-container *ngTemplateOutlet="hVideo"></ng-container>
                        }
                    </button>
                    } @if(asset.type === assetMediaType.Video && isMobile && !isServer){
                    <ng-container *ngTemplateOutlet="hVideo"></ng-container>
                    }
                    <ng-template #hVideo>
                        <h-video
                            [videoButtonContainer]="isMobile ? undefined : videoButtonContainer"
                            [isLightMode]="true"
                            [alwaysShowControls]="true"
                            [buttonShadow]="false"
                            [detectViewportOnce]="false"
                            [detectViewportTreeshold]="0"
                            [videoRatio]="'1-1'"
                            [controlSize]="'medium'"
                            [mediaType]="'snackable_video'"
                            [controlPosition]="isMobile ? 'low' : 'external'"
                            [isLightMode]="true"
                            [isPlaying]="startVideo"
                            [posterUrl]="asset.posterUrl"
                            [videoName]="asset.title ?? ''"
                            [videoUrl]="asset.url"
                            [backgroundActive]="false">
                            <img
                                [alt]="asset.title ?? ''"
                                [width]="productImageIntrinsecSize"
                                [height]="productImageIntrinsecSize"
                                [ngSrc]="getVideoPosterUrl()(idx)"
                                priority />
                        </h-video>
                    </ng-template>
                </div>
                }
            </h-carousel>
        </div>
        }
        <div class="float-bottom-right-container">
            <div #videoButtonContainer class="video-button"> </div>
            <div class="vto-button">
                @if (isVtoEnabled && !isServer && hasTransition) {
                <h-virtual-try-on-button
                    id="virtual-try-on-button"
                    [hasTransition]="hasTransition"
                    [pageType]="'single product page'">
                </h-virtual-try-on-button>
                }
            </div>
        </div>
    </div>
    @if (hasExternalItems) {
    <div class="external-panel" [class.external-panel--large]="productPageFacade.isProductPageSelectorRevampEnabled">
        <ng-content select="[items]"> </ng-content>

        <!-- We display toggles here only on mobile if there are external items -->

        <ng-container [ngTemplateOutlet]="toggles"></ng-container>
    </div>
    } @if (storyBehind) {
    <div
        class="external-panel"
        [class.external-panel--large-story-behind]="productPageFacade.isProductPageSelectorRevampEnabled">
        <div
            class="product-story-behind"
            [class.product-story-behind--large]="productPageFacade.isProductPageSelectorRevampEnabled">
            <h-story-behind [storyBehind]="storyBehind"></h-story-behind>
        </div>
    </div>
    }

    <div class="external-panel" [class.external-panel--large]="productPageFacade.isProductPageSelectorRevampEnabled">
        <h-product-page-cross-sell></h-product-page-cross-sell>
    </div>
</div>
